<style>
@import 'assets/css/common.css';
#app {
  height: 100%;
  width: 100%;
}
</style>
<template>
  <div id="app">
    <my-header></my-header>
    <router-view />
    <my-footer></my-footer>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>
<script>
import MyHeader from '@/components/MyHeader'
import MyFooter from '@/components/MyFooter'

export default {
  data () {
    return {
    };
  },
  components: {
    MyHeader,
    MyFooter
  },
  beforeCreate () { },
  created () {
  },
  mounted () {
  },
  beforeDestroy () { },
  computed: {},
  methods: {
  },
};
</script>
